import { render, staticRenderFns } from "./HxPage.vue?vue&type=template&id=07698440&scoped=true&"
import script from "./HxPage.vue?vue&type=script&lang=js&"
export * from "./HxPage.vue?vue&type=script&lang=js&"
import style0 from "./HxPage.vue?vue&type=style&index=0&id=07698440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07698440",
  null
  
)

export default component.exports